<template>
    <b-img class="orange-bg" :src="`${routes.cdn_url}/images/redesign/orange-background.png`" fluid alt="Wavey orange background with various math symbols and numbers"></b-img>
</template>

<script>
    export default {
    }
</script>

<style lang="scss" scoped>
    .orange-bg {
        position: absolute;
        top: -15vh;
        width: 100vw;
        z-index: -1;
    }
    // @media (max-width: 1200px) {
    //     // rules here apply to devices from 993px to 1200px (inclusive)
    // }
    // @media (max-width: 992px) {	
    //     // rules here apply to devices from 769px to 992px (inclusive)
    // }
    // @media (max-width: 768px) {
    //     // rules here apply to devices from 0px to 768px (inclusive)
    // }
</style>
